<template>
  <div class="w-full h-full flex flex-col px-12px py-12px justify-start overflow-auto">

    <div class="masonry" ref="gridRef">
      <div v-for="item in resourceList" :key="item.id" class="masonry-item cursor-pointer">
        <div class="masonry-content" @click="handleClick(item)">
          <img :src="item.full_preview_url" alt="" class="media" />
        </div>
      </div>
    </div>
    <div v-if="resourceList.length === 0">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = defineProps({
  id: {
    type: String,
    default: ''
  }
})
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})

const resourceList = ref([])
const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 2, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

defineExpose({ getList })

// 移除基于 grid 行高的测量逻辑，改用 CSS columns 布局



onMounted(() => {


})


const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}
</script>

<style lang="scss" scoped>
.masonry {
  display: flex;
  grid-gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
}

.masonry-content {
  width: 124px;
  height: 100px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 10px;
  cursor: pointer;

  img {
    margin: auto;
    height: 100%;
    display: block;
  }
}

.masonry-content:hover {
  background: #eeeeee;
}
</style>
